<template>
  <div class="live mt-1" id="live">
    <b-row class="m-0 text-center instance">
      <b-col class="p-0">
        <div class="img-cover"></div>
        <div id="player_live"></div>
        <!-- <img class="d-block img-fluid w-100" src="@/assets/imgs/home/item1.png" alt="" /> -->
        <!-- <div class="innerbox">
          <div class="instance-txt">
            <i class="vedio_icon"></i>
            2 New Imported Cases Reported In Shanghai
          </div>
          <span class="metro-btn">M E T R O</span>
        </div>
        <div class="cover"></div>
        <div class="liveFlag">· live</div> -->
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "LiveInstance",
  props: ["liveAddress", "featureInfo"],
  data() {
    return {
      playerHeight: "",
    };
  },
  mounted() {
    this.setPlayerheight();

    if (this.liveAddress) {
      this.initAly();
    }

    // console.log(this.featureInfo, "1111");
  },
  methods: {
    setPlayerheight() {
      var container = document.getElementById("live");
      if (container.clientWidth > 750) {
        this.playerHeight = (container.clientWidth - 30) / (16 / 9) + "px";
        console.log(this.playerHeight, "playerHeight111");
      } else {
        this.playerHeight = container.clientWidth / (16 / 9) + "px";
        console.log(this.playerHeight, "playerHeight222");
      }
    },
    initAly() {
      this.coverImg =
        this.$store.state.baseUrl + this.featureInfo.featureImgUrl;
      var alplayer = new Aliplayer(
        {
          id: "player_live",
          source: this.liveAddress,
          cover: this.coverImg, //播放器封面图
          width: "100%",
          height: this.playerHeight,
          // height: "300px",
          autoplay: true,
          isLive: true,
          rePlay: false,
          playsinline: true,
          preload: true,
          controlBarVisibility: "hover",
          useH5Prism: true,
        },
        function(player) {
          console.log("The player is created");
        }
      );
    },
  },
};
</script>
<style lang="less" scoped>
// instance
.live {
  width: 100%;
  float: left;
  margin-top: 0.2rem;
  overflow: hidden;
  position: relative;

  .prism-player .prism-big-play-btn {
    position: absolute;
    left: 50% !important;
    top: 50% !important;
    display: block;
    transform: translate(-50%, -50%);
  }
}
.instance {
  font-family: FranklinGothic-Demi;
  color: #ffffffff;
  .liveFlag {
    font-size: 0.3rem;
    position: absolute;
    left: 50px;
    top: 50px;
    font-weight: bold;
  }
  #player_live {
    // min-height: 400px;
    font-size: 20px;
  }
}
.innerbox {
  width: calc(100% - 0.4rem);
  margin: 0 0.2rem;
  font-size: 0.6rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  .vedio_icon {
    display: inline-block;
    height: 0.6rem;
    width: 0.6rem;
    background: url("../../../assets/imgs/home/vedio_icon.png") no-repeat;
    background-size: 100% 100%;
    cursor: pointer;
    position: relative;
    top: 0.1rem;
  }
  .metro-btn {
    position: relative;
    top: 0.5rem;
    border: 1.3px solid #ffffff;
    padding: 0.1rem;
    cursor: pointer;
    font-size: 0.28rem;
  }
  .metro-btn:hover {
    background: #666666;
    border: none;
    border-radius: 5px;
  }
}
@media screen and (max-width: 768px) {
  .instance {
    .liveFlag {
      font-size: 12px;
      position: absolute;
      left: 15px;
      top: 10px;
      font-weight: bold;
    }
    #player_live {
      // height: 300px;
      font-size: 12px;
    }
  }
  .innerbox {
    width: calc(100% - 0.4rem);
    margin: 0 0.2rem;
    font-size: 20px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .vedio_icon {
      display: inline-block;
      height: 20px;
      width: 20px;
      background: url("../../../assets/imgs/home/vedio_icon.png") no-repeat;
      background-size: 100% 100%;
      cursor: pointer;
      position: relative;
      top: 0.1rem;
    }
    .metro-btn {
      position: relative;
      top: 0.2rem;
      border: 1.3px solid #ffffff;
      padding: 0.1rem;
      cursor: pointer;
      font-size: 9px;
    }
    .metro-btn:hover {
      background: #666666;
      border: none;
      border-radius: 5px;
    }
  }
}
</style>
